export default "__VITE_ASSET__CcWWispE__"